import { hooks } from '@approvalmax/utils';

export const useMatchXeroPopupQueryParams = () => {
    const [consentId, setConsentId, cleanConsentId] = hooks.useQueryParam('consent-id');
    const [bankAccountId, setBankAccountId, cleanBankAccountId] = hooks.useQueryParam('bank-account-id');
    const [reMatch, setReMatch, cleanReMatch] = hooks.useQueryParam('rematch');

    return {
        consentId,
        setConsentId,
        cleanConsentId,
        bankAccountId,
        setBankAccountId,
        cleanBankAccountId,
        reMatch,
        setReMatch,
        cleanReMatch,
    };
};
